import React from 'react';
import glamorous from 'glamorous';

import taraBaseballOneSvg from '../../../assets/taraBaseballOne.svg';
import taraBaseballTwoSvg from '../../../assets/taraBaseballTwo.svg';
import taraDefaultOneSvg from '../../../assets/taraDefaultOne.svg';
import taraDefaultTwoSvg from '../../../assets/taraDefaultTwo.svg';
import taraFootballOneSvg from '../../../assets/taraFootballOne.svg';
import taraHockeyOneSvg from '../../../assets/taraHockeyOne.svg';

const avatars = {
  baseballOne: taraBaseballOneSvg,
  baseballTwo: taraBaseballTwoSvg,

  defaultOne: taraDefaultOneSvg,
  defaultTwo: taraDefaultTwoSvg,

  footballOne: taraFootballOneSvg,

  hockeyOne: taraHockeyOneSvg,
};

const avatarKeys = Object.keys(avatars);
// const randomIndex = Math.floor(Math.random() * avatarKeys.length);
// const initialAvatarType = avatarKeys[randomIndex];
const initialAvatarType = 'baseballTwo';

const Container = glamorous.div(({ theme, marginRight, width }) => ({
  width: width || 72,
  flexShrink: 0,
  marginRight,
  userSelect: 'none',
}));

const Image = glamorous.img(({ theme }) => ({
  display: 'block',
  margin: '0 auto',
  width: 'auto',
  height: 'auto',
  maxWidth: '100%',
  maxHeight: 72,
}));

const TaraAvatar = (props) => {
  const {
    marginRight,
    type,
    width,
    ...rest
  } = props;

  return (
    <Container
      marginRight={marginRight}
      width={width}
    >
      <Image
        src={avatars[type]}
        {...rest}
      />
    </Container>
  );
};


TaraAvatar.defaultProps = {
  type: initialAvatarType,
  marginRight: 16,
};

export default TaraAvatar;




// WEBPACK FOOTER //
// ./src/components/features/Tara/TaraAvatar.js